Confirm = require 'app/scripts/views/lib/confirm'
SelectMemberView = require 'app/scripts/views/member/select-member-view'

module.exports = class ConfirmAddEmail extends Confirm
  constructor: ->
    super
    @template = 'confirm_merge'

  render: ->
    super
    @appendSubview @subview(SelectMemberView, @model), @$('.js-member')
    @
